<template>
<div>
  <AppHeader title="Cashier Invoices" />
    <div class="container">
    <div class="container left">
      <div class="row" style="padding-left: 15px">
        <!-- <div class="col-sm-1">
          <div
            class="dropdown"
            style="
              position: fixed;
              left: 0;
              top: 0;
              padding: 0;
              margin-top: 0;
              margin-bottom: 0;
            "
          >
            <ReportsMenu />
          </div>
        </div> -->
        <div class="col-sm-17" style="color: white">
          <table width="100%">
            <tr>
              <td>
                <table>
                  <tr>
                    <td>
                      <label title="User" style="font-size: 1.2em">User:</label>
                    </td>
                    <td>
                      <input
                        type="checkbox"
                        @click="handleAll()"
                        id="select_all"
                        style="font-size: 1.5em"
                      />
                    </td>
                  </tr>
                </table>
              </td>
              <td>
                <select
                  id="paid_by"
                  v-model="paid_by"
                  name="paid_by"
                  style="color: black; font-size: 1.3em"
                >
                  <option value="0">Select a cashier</option>
                </select>
              </td>
              <td>
                <table>
                  <tr>
                    <td>
                      <label title="PaymetType" style="font-size: 1.2em"
                        >Paymet Type:</label
                      >
                    </td>
                    <td>
                      <input
                        type="checkbox"
                        @click="handleAllPaymetType()"
                        id="select_all_payment_type"
                        style="font-size: 1.5em"
                      />
                    </td>
                  </tr>
                </table>
              </td>
              <td>
                <select
                  id="payment_type"
                  v-model="payment_type"
                  name="payment_type"
                  style="color: black; font-size: 1.3em"
                >
                  <option value="0">Select Payment Type</option>
                  <option
                    v-for="paymentType in paymentTypes"
                    :key="paymentType.value"
                    :value="paymentType.value"
                  >
                    {{ paymentType.name }}
                  </option>
                </select>
              </td>
              <td>
                <label title="Date" style="font-size: 1.5em; color: white"
                  >Date:</label
                >
              </td>
              <td>
                <div class="col-sm-2" style="text-align: center; color: black">
                  <datepicker
                    v-model="state.date"
                    name="selected_date"
                    format="yyyy-MM-dd"
                    @selected="parentfunctionSelectedhandler"
                    @opened="datepickerOpenedFunction"
                    @closed="parentfunctionCloseHandler"
                  ></datepicker>
                </div>
              </td>
              <!--
              <td>
                <label title="Date" style="font-size:1.5em;color: white">Invoice:</label>
              </td>
              <td>
                <input type="text" class="form-control" name="orderId" v-model="orderId">
              </td>
              -->
              <td>
                <button
                  class="btn btn-success"
                  style="font-size: 1.5em; scale: 1.12; margin-left: -85%"
                  @click="findCashierInvoices()"
                >
                  Find
                </button>
              </td>
            </tr>
          </table>
          <br />
          <br />
          <div></div>
        </div>
      </div>

      <br />

      <div v-if="toggle">
        <div v-if="!checkNoResults()" style="text-align: right">
          <button
            class="btn btn-success"
            style="font-size: 1.5em"
            @click="
              exportToExel(
                'Cashier Invoices',
                payments.map((el) => {
                  el.amount = formatNumber(el.amount);
                  return el;
                })
              )
            "
          >
            Export To Exel
          </button>
        </div>
        <div v-if="checkNoResults()" style="text-align: center">
          <div
            v-if="select_all"
            style="
              font-size: 2em;
              text-align: center;
              background-color: #999999;
            "
          >
            No Data Found
          </div>
        </div>

        <div
          class="row table-wrap"
          style="
            color: #fff;
           
            overflow-y: auto;
            max-height: 450px;
          "
        >
          <!--<div v-if="select_all" style="font-size:2em;text-align: center;background-color: #999999;">Customers Payments Of {{user_name}} On {{dateToYMD(this.state.date)}}</div>-->
          <!--<div v-if="!select_all"  style="font-size:2em;text-align: center;background-color: #999999;">Customers Payments On {{dateToYMD(this.state.date)}}</div>-->
          <table class="table" style="color: #fff">
            <thead>
              <tr>
                <th
                  style="
                    font-size: 1.5em;
                    text-align: right;
                    background-color: black;
                  "
                >
                  Invoice NO
                </th>
                <th
                  style="
                    font-size: 1.5em;
                    text-align: right;
                    background-color: black;
                  "
                >
                  Payment Type
                </th>
                <!--<th  style="font-size:1.5em;text-align: right;background-color: black;">PaymentDate</th>-->
                <th
                  style="
                    font-size: 1.5em;
                    text-align: right;
                    background-color: black;
                  "
                >
                  Amount
                </th>
                <!--<th  style="font-size:1.5em;text-align: right;background-color: black;">Cashier</th>-->
              </tr>
            </thead>
            <tbody>
              <tr v-for="item in payments" :key="item.orderId">
                <td style="font-size: 1.5em; text-align: right">
                  {{ item.orderId }}
                </td>
                <td style="font-size: 1.5em; text-align: right">
                  {{ item.paymentType }}
                </td>
                <!--<td style="font-size:1.5em;text-align: right;">{{item.date_added}}</td>-->
                <td style="font-size: 1.5em; text-align: right">
                  {{ formatNumber(item.amount) }}
                </td>
                <!--<td style="font-size:1.5em;text-align: right;">{{item.added_by}}</td>-->
              </tr>
              <tr>
                <td
                  style="
                    font-size: 1.5em;
                    text-align: right;
                    background-color: black;
                  "
                >
                  <h3>Total</h3>
                </td>
                <!--<td style="font-size:1.5em;text-align: right; background-color: black;"><h3></h3></td>
                <td style="font-size:1.5em;text-align: right; background-color: black;"><h3></h3></td>-->
                <td
                  style="
                    font-size: 1.5em;
                    text-align: right;
                    background-color: black;
                  "
                >
                  <h3></h3>
                </td>
                <td
                  style="
                    font-size: 1.5em;
                    text-align: right;
                    background-color: black;
                  "
                >
                  <h3>{{ formatNumber(payment_totals) }}</h3>
                </td>
              </tr>
            </tbody>
          </table>
          <hr />
        </div>
      </div>
    </div>
  </div>
</div>
</template>

<script>
import axios from "axios";
import commonServices from "@/shared/commonServices";
import ReportsMenu from "@/components/ReportsMenu";
//import DatePick from 'vue-date-pick';
import Datepicker from "vuejs3-datepicker";
import AppHeader from "@/components/AppHeader";
import "vue-date-pick/dist/vueDatePick.css";
export default {
  mixins: [commonServices],
  mounted() {
    this.$el.querySelector("#paid_by").disabled = true;
    this.$el.querySelector("#payment_type").disabled = true;
    const nowDate = new Date();
    let year = nowDate.getFullYear();
    let month = nowDate.getMonth();
    let day = nowDate.getDate();
    this.state.date = new Date(year + "", month + "", day + "");
    this.orderDate = this.state.date;
    //console.log("this.state.date", this.state.date)
    this.getUsers();
    this.getPaymentTypes();
    if (localStorage.userId === undefined) {
      //this.$router.push({ name: 'login'});
    }
    this.language = "ar";
    this.handleLanguage();
    this.getLogo();
    if (localStorage.reports_ok === "1") {
      this.reports_ok = true;
    }
    this.logoImage =
      '<img src="' + this.logoUrl + '" width="70" height="50" alt="Logo">';
  },
  components: {AppHeader , Datepicker },
  data: function () {
    return {
      state: { date: new Date(1000, 0, 1) },
      users: [],
      paymentTypes: [],
      usersJson: {},
      reports_ok: false,
      select_all: false,
      select_all_payment_type: false,
      dailySales: [],
      showError: false,
      logoImage: "",
      orderId: "",
      payment_totals: 0,
      userSalesPaymentJson: {},
      mainErrorMsg: "",
      logoUrl: "",
      user_name: "",
      payment_total_amount: "",
      customer_payments_amount: "",
      totalSalesAmount: "",
      jsonData: {},
      language: "en",
      languageName: "",
      toggle: false,
      orderDate: "",
      paid_by: 0,
      payment_type: "0",
    };
  },
  methods: {
    parentfunctionSelectedhandler() {
      this.payments = [];
      this.toggle = false;
      this.payment_totals = 0;
    },
    datepickerOpenedFunction() {},
    parentfunctionCloseHandler() {},
    addOption(selectbox, value, text) {
      var optn = document.createElement("OPTION");
      optn.text = text;
      optn.value = value;
      selectbox.options.add(optn);
    },

    checkNoResults() {
      let showResults = false;
      if (this.payments.length == 0) {
        showResults = true;
      }
      return showResults;
    },

    handleAllPaymetType() {
      this.payments = [];
      if (this.select_all_payment_type) {
        this.select_all_payment_type = false;
        this.$el.querySelector("#payment_type").disabled = true;
      } else {
        this.select_all_payment_type = true;
        this.$el.querySelector("#payment_type").disabled = false;
      }
    },
    handleAll() {
      this.payments = [];
      if (this.select_all) {
        this.select_all = false;
        this.$el.querySelector("#paid_by").disabled = true;
      } else {
        this.select_all = true;
        this.$el.querySelector("#paid_by").disabled = false;
      }
    },

    findCashierInvoices: async function () {
      this.orderDate = this.state.date;

      this.userSalesPaymentJson.appId = localStorage.appId;
      this.userSalesPaymentJson.orderDate = this.dateToYMD(this.state.date);
      if (this.orderId !== 0) {
        this.userSalesPaymentJson.orderId = this.orderId;
      }
      if (this.paid_by !== 0) {
        this.userSalesPaymentJson.paid_by = this.paid_by;
      }
      if (this.payment_type !== "0") {
        this.userSalesPaymentJson.payment_type = this.payment_type;
      }

      try {
        let dataURL = this.apiURL + "GiftCard/findCashierPayment";
        let response = await axios.post(dataURL, this.userSalesPaymentJson);
        if (response.data.status === "success") {
          this.toggle = true;
          this.payments = response.data.results.payments;
          this.payment_totals = response.data.results.total_amount;
        }
      } catch (error) {
        console.log(error);
      }
    },
    printReport() {
      const nowDate = new Date();
      let year = nowDate.getFullYear();
      let month = nowDate.getMonth() + 1;
      let day = nowDate.getDate();
      let reportDate = year + "-" + month + "-" + day;
      var today = new Date();
      var time =
        today.getHours() + ":" + today.getMinutes() + ":" + today.getSeconds();
      let reportHeader = "";
      let reportFooter =
        "Printed on: " + year + "-" + month + "-" + day + " " + time;
      this.printUserSalesPaymentReport(
        reportDate,
        reportHeader,
        reportFooter,
        this.payments,
        this.payment_totals
      );
    },
    printUserSalesPaymentReport(
      reportDate,
      reportHeader,
      reportFooter,
      customer_payments,
      payment_totals
    ) {
      let viaInvStr = '<table width="100%">';
      viaInvStr = viaInvStr + "<tr><td>";
      viaInvStr = viaInvStr + "<tr><td>";
      viaInvStr =
        viaInvStr +
        '<table align="center" width="100%"  style="border-bottom: #000000 2px solid; vertical-align:bottom"><tr><td  align="center" style="vertical-align:bottom"><b><p style="font-size:1.5em">' +
        reportHeader +
        "</p></b></td></tr></table>";
      viaInvStr = viaInvStr + "</td></tr>";
      viaInvStr = viaInvStr + "<tr><td>";
      viaInvStr =
        viaInvStr +
        '<table align="left" width="100%"  style="border-bottom: #000000 2px solid;"><tr><td align="left" ><b><p style="font-size:1.5em">Date:</p></b></td><td align="left"><b><p style="font-size:1.5em">' +
        reportDate +
        "</p></b></td></tr></table>";
      viaInvStr = viaInvStr + "</td></tr>";
      viaInvStr = viaInvStr + "<tr><td>";
      viaInvStr = viaInvStr + '<table align="left" width="100%">';
      viaInvStr =
        viaInvStr +
        '<tr><td align="left"><b><p style="font-size:1.5em">Invoice No</p></b></td><td align="left"><b><p style="font-size:1.5em">Payment Type</p></b></td><td align="left"><b><p style="font-size:1.5em">Payment Date</p></b></td><td align="right"><b><p style="font-size:1.5em">Amount</p></b></td><td align="left"><b><p style="font-size:1.5em">Caheier</p></b></td></tr>';
      customer_payments.forEach(function (item) {
        viaInvStr = viaInvStr + "<tr>";
        viaInvStr =
          viaInvStr +
          '<td align="left"><p style="font-size:1.5em">' +
          item.orderId +
          "</p></td>";
        viaInvStr =
          viaInvStr +
          '<td align="left"><p style="font-size:1.5em">' +
          item.paymentType +
          "</p></td>";
        viaInvStr =
          viaInvStr +
          '<td align="left"><p style="font-size:1.5em">' +
          item.date_added +
          "</p></td>";
        viaInvStr =
          viaInvStr +
          '<td align="right"><p style="font-size:1.5em">' +
          item.amount +
          "</p></td>";
        viaInvStr =
          viaInvStr +
          '<td align="left"><p style="font-size:1.5em">' +
          item.added_by +
          "</p></td>";
        viaInvStr = viaInvStr + "</tr>";
      });
      viaInvStr =
        viaInvStr +
        '<tr><td align="left"><b><p style="font-size:1.5em">Totals</p></b></td><td align="left"><b><p style="font-size:1.5em"></p></b></td><td align="left"><b><p style="font-size:1.5em"></p></b></td><td align="right"><b><p style="font-size:1.5em">' +
        payment_totals +
        '</p></b></td><td align="left"><b><p style="font-size:1.5em"></p></b></td></tr>';
      viaInvStr = viaInvStr + "</td></tr>";
      viaInvStr = viaInvStr + "</table>";

      //viaInvStr = viaInvStr + '<tr><td>';
      //viaInvStr = viaInvStr + '<table align="center" width="100%"  style="border-bottom: #000000 2px solid; vertical-align:bottom"><tr><td width="100%" align="center" style="vertical-align:bottom"><b><p style="font-size:1.5em">'+reportFooter+'</p></b></td></tr></table>';
      //viaInvStr = viaInvStr + '</td></tr>';

      viaInvStr = viaInvStr + "</table>";
      this.sharedPrintElemmRep(viaInvStr);
    },

    getPaymentTypes: async function () {
      this.usersJson.appId = localStorage.appId;
      let usersJson_ = JSON.stringify(this.usersJson);
      try {
        let dataURL = this.apiURL + "GiftCard/getPaymentTypes";
        let response = await axios.post(dataURL, usersJson_);
        if (response.data.status === "success") {
          this.paymentTypes = response.data.results;
        }
      } catch (error) {
        console.log(error);
      }
    },

    getUsers: async function () {
      this.usersJson.appId = localStorage.appId;
      let usersJson_ = JSON.stringify(this.usersJson);
      try {
        let dataURL = this.apiURL + "GiftCard/getPosUsers";
        let response = await axios.post(dataURL, usersJson_);
        if (response.data.status === "success") {
          this.users = response.data.results;
          //this.users = this.json2array(response.data.results);

          var dropdown = document.getElementById("paid_by");
          if (dropdown) {
            for (var i = 0; i < this.users.length; ++i) {
              this.addOption(dropdown, this.users[i].id, this.users[i].partOne);
            }
          }
        }
      } catch (error) {
        console.log(error);
      }
    },
    getLogo: async function () {
      try {
        let dataURL = this.apiURL + "Orders/getInvoiceLogo";
        let logoJson = { appId: localStorage.appId };
        let response = await axios.post(dataURL, logoJson);
        if (response.data.status === "success") {
          this.logoUrl = response.data.results.logourl;
        }
      } catch (error) {
        console.log(error);
      }
    },
  },
};
</script>
<style>
#app {
  font-family: "Avenir", Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: left;
  color: #2c3e50;
  margin-top: 20px;
}

.glyphicon.glyphicon-ok {
  font-size: 30px;
}

.button {
  font: bold 15px Arial;
  text-decoration: none;
  background-color: #eeeeee;
  color: #333333;
  /* padding: 2px 6px 2px 6px;
  border-top: 1px solid #cccccc;
  border-right: 1px solid #333333;
  border-bottom: 1px solid #333333;
  border-left: 1px solid #cccccc; */
}
.grid-container-element {
  display: grid;
  grid-template-columns: 5fr 1.5fr 1.5fr 1.5fr 0.5fr;
  grid-gap: 10px;
  border: 1px solid whitesmoke;
  border-left: 0px;
  border-right: 0px;
  border-top: 0px;
  width: 100%;
}
.grid-child-element_ {
  margin: 10px;
  border: 1px solid red;
}
.grid-child-element {
  margin: 2px;
  border-left: 0px;
  border-right: 0px;
  border-top: 0px;
  padding: 0 px;
}
</style>
